export class CameraError extends Error {
  constructor(kind, cause) {
    super(kind);
    this.name = "CameraError";
    this.kind = kind;
    this.cause = cause;
  }
}

export class CameraController {
  constructor(video, mediaDevices = globalThis.navigator?.mediaDevices) {
    this.video = video;
    this.mediaDevices = mediaDevices;
    this.stream = null;
    this.facingMode = "environment";
  }

  get active() {
    return Boolean(this.stream);
  }

  async start(facingMode = this.facingMode) {
    if (!this.mediaDevices?.getUserMedia) throw new CameraError("missing");
    this.stop();
    try {
      this.stream = await this.mediaDevices.getUserMedia({
        audio: false,
        video: { facingMode: { ideal: facingMode }, width: { ideal: 1280 }, height: { ideal: 960 } }
      });
    } catch (error) {
      const kind = error?.name === "NotAllowedError" || error?.name === "SecurityError" ? "denied"
        : error?.name === "NotFoundError" || error?.name === "OverconstrainedError" ? "missing" : "error";
      throw new CameraError(kind, error);
    }
    this.facingMode = facingMode;
    this.video.srcObject = this.stream;
    this.video.setAttribute("playsinline", "");
    this.video.muted = true;
    await this.video.play();
    return this.stream;
  }

  async flip() {
    return this.start(this.facingMode === "environment" ? "user" : "environment");
  }

  stop() {
    this.stream?.getTracks().forEach((track) => track.stop());
    this.stream = null;
    if (this.video) this.video.srcObject = null;
  }
}
